/**
 * @generated SignedSource<<656b0d44239f7eb3a8ba9659e9762f2f>>
 * @relayHash f18661cc7a1d2d55f19018b453d74e49
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5b9f82627568e61d5a48e4bdd045a30d7fc6ac7b992beec39feead5b18838e62

import type { ConcreteRequest, Query } from 'relay-runtime';
export type SpaceViewsPersistenceOption = "POPULARITY" | "RECENTLY_MODIFIED" | "RECENTLY_VIEWED" | "TITLE_AZ" | "TREE" | "%future added value";
export type useSpaceViewsOptionsPersistenceQuery$variables = {
  spaceKey: string;
};
export type useSpaceViewsOptionsPersistenceQuery$data = {
  readonly userPreferences: {
    readonly spaceViewsPersistence: SpaceViewsPersistenceOption;
  } | null | undefined;
};
export type useSpaceViewsOptionsPersistenceQuery = {
  response: useSpaceViewsOptionsPersistenceQuery$data;
  variables: useSpaceViewsOptionsPersistenceQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "concreteType": "UserPreferences",
    "kind": "LinkedField",
    "name": "userPreferences",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "spaceKey",
            "variableName": "spaceKey"
          }
        ],
        "kind": "ScalarField",
        "name": "spaceViewsPersistence"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useSpaceViewsOptionsPersistenceQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSpaceViewsOptionsPersistenceQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f18661cc7a1d2d55f19018b453d74e49",
    "id": "5b9f82627568e61d5a48e4bdd045a30d7fc6ac7b992beec39feead5b18838e62",
    "metadata": {},
    "name": "useSpaceViewsOptionsPersistenceQuery",
    "operationKind": "query",
    "text": "query useSpaceViewsOptionsPersistenceQuery($spaceKey:String!){userPreferences{spaceViewsPersistence(spaceKey:$spaceKey)}}"
  }
};
})();

(node as any).hash = "cc599626e8f53c4256f22a11dfce92c8";

export default node;
